// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"879b9b5a","304":"0de4bca2","379":"293c9481","608":"47fc0e0e","865":"ad2712ed","906":"16a076a6"}[chunkId] + ".chunk.js";
};